module.exports = __webpack_public_path__ + "image/store-big.d1a98b7.jpg";